
























import { Image, Lazyload } from 'vant';
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import { RequestState } from "@/network/http";
import { AreaInfo } from '@/data/local/common'

Vue.use(Image);
Vue.use(Lazyload);

@Component({})
export default class AccountLayout extends Vue {
    @Prop(Object)
    private city: AreaInfo;

    accountBg: any = require("../assets/images/bg_main_card.png");


    created() {
  
    }

    mounted() {
  
    }

    get loginState(): boolean {
        return false;
    }

    queryFund() {
        let url = "http://app.gjj.sz.gov.cn/pages/wy_yecx.jsp";
        this.$router.push({path: "/fund/account/query/" + this.city.id, query:{ url: encodeURI(url)}});
    }
}

